import type { MessengerMessage } from '@/api/client';

/** Одна ссылка на пустой список — чтобы `initialForwardMsgs` не менялся каждый рендер и эффект в композере не дёргал стейт. */
export const MESSENGER_EMPTY_FORWARD_DRAFT: MessengerMessage[] = [];
